<template>
  <div class="row">
    <div class="col-12 col-md-6">
      <div :class="['row', $isDesktop ? 'q-col-gutter-lg' : 'q-col-gutter-md']">
        <div class="col-12">
          <common-input
              v-model="form.title"
              label="Titel"
              name="title"
              :error-message="$errorMessage('title')"
              :error="$hasError('title')"
              required
              autofocus
          />
        </div>
        <div class="col-12">
          <common-input
              v-model="form.manager"
              label="Contactpersoon intern"
              name="manager"
              :error-message="$errorMessage('manager')"
              :error="$hasError('manager')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    objectGroup: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: {
        title: this.$old('title', this.objectGroup?.title),
        manager: this.$old('manager', this.objectGroup?.manager),
      }
    }
  }
}
</script>
